import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';

import { environment } from '../../../../environments/environment.development';
import { SessionService } from '../../../auth/services/session/session.service';
import { LayoutComponent } from '../../../shared/layouts/layout/layout.component';
import { LoadingService } from '../../../shared/services/loading/loading.service';
import { MipService } from '../../services/mip/mip.service';

@Component({
  selector: 'app-mip-folders',
  standalone: true,
  imports: [
    LayoutComponent,
    CalendarModule,
    ReactiveFormsModule,
    DropdownModule,
    CheckboxModule,
    DialogModule,
  ],
  templateUrl: './mip-folders.component.html',
  styleUrl: './mip-folders.component.scss',
})
export class MipFoldersComponent {
  private _mipService = inject(MipService);
  private _loading = inject(LoadingService);
  private _sessionService = inject(SessionService);

  public reportsForm: FormGroup;

  constructor(private _formBuilder: FormBuilder) {
    this.reportsForm = this._formBuilder.group({
      initialDate: [null, Validators.required],
      finalDate: [null, Validators.required],
      CT: [[]],
      RP: [[]],
      // OR: [[]],
      RM: [[]],
      QO: [[]],
    });
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    this._loading.show();

    if (this._sessionService.CompanyStatus !== 'company-paid') {
      window.open('https://pestforceapp.com/payment-overdue', '_blank');
      this._loading.hide();
      return;
    }

    if (this.reportsForm.valid) {
      const initialDate = this.reportsForm.get('initialDate')?.value;
      const formattedInitialDate = initialDate
        ? initialDate.toISOString().split('T')[0]
        : null;

      const finalDate = this.reportsForm.get('finalDate')?.value;
      const formattedFinalDate = finalDate
        ? finalDate.toISOString().split('T')[0]
        : null;

      const CT = this.reportsForm.get('CT')?.value;
      const RP = this.reportsForm.get('RP')?.value;
      const RM = this.reportsForm.get('RM')?.value;
      const QO = this.reportsForm.get('QO')?.value;

      const ctIsChecked = CT && CT.length > 0;
      const rpIsChecked = RP && RP.length > 0;
      const rmIsChecked = RM && RM.length > 0;
      const qoIsChecked = QO && QO.length > 0;

      this._mipService
        .getCalendarDocument(
          formattedInitialDate,
          formattedFinalDate,
          ctIsChecked,
          rpIsChecked,
          rmIsChecked,
          qoIsChecked,
        )
        .subscribe({
          next: (response) => {
            const url = response.data.startsWith('http')
              ? response.data
              : environment.documentStorageUrl + response.data;

            const a = document.createElement('a');
            a.href = url;
            a.download = '';
            a.click();
          },
          complete: () => this._loading.hide(),
        });
    } else {
      this.reportsForm.markAllAsTouched();
    }
  }
}
